export default {
  common: {
    title: 'レジカメラ',
    cancel: 'キャンセル',
    ok: 'OK',
    search: '検索',
    all: '全て',
    not_set: '未設定',
    male: '男性',
    female: '女性',
    image_dialog: '拡大画像',
    not_found: '表示するデータはありません。',
  },
  login: {
    title: '管理者ログイン',
    username: {
      label: 'ログインID',
      placeholder: 'メールアドレスを入力',
    },
    password: {
      label: 'パスワード',
      placeholder: 'パスワードを入力',
    },
    submit: 'ログイン',
  },
  side_bar: {
    visitor_list: '訪問者一覧',
    dashboard: '統計',
    database: 'DB選択',
    setting_db: {
      title: 'DB再設定',
      placeholder: '設定画面に戻ります。よろしいでしょうか。',
    },
    tag: {
      title: 'タグ編集',
      dialog_title: 'タグ編集',
      label: 'タグ',
      placeholder: 'タグを選択してください',
    },
  },
  home: {
    title: '訪問者一覧',
    image: '画像',
    id_number: 'ID番号',
    start: '開始',
    end: '終了',
    person_photo: '本人画像',
    control_number: '管理番号',
    start_time: '来店時間',
    end_time: '退店時間',
    tag: 'タグなど',
  },
  user_detail: {
    title: '訪問一覧',
    id: 'ID',
    age: '年齢',
    age_placeholder: '年齢を入力してください',
    gender: '性別',
    gender_placeholder: '性別を選択してください',
    first_date: '初回登録日時',
    free_text: '自由テキスト',
    tag: 'タグ',
    comment: 'メモ',
    camera: 'カメラ',
    location: 'ロケーション',
    dialog: {
      title: 'リファレンスID削除',
      content: 'データーを削除します。よろしいでしょうか？',
    },
  },
  visit_detail: {
    title: 'キャプチャー一覧',
    capture_time: 'キャプチャー時間',
  },
  setting: {
    logout: 'ログアウト',
    db: 'DB指定・管理',
    app_config: 'APP認証',
    db_setting: 'DB設定',
    db_config: 'DBの選択',
    db_setting_contents: '設定画面に戻ります。よろしいでしょうか。',
    url: {
      label: 'URL',
      placeholder: 'URLを入力してください',
    },
    app_id: {
      label: 'APP ID',
      placeholder: 'APP IDを入力してください',
    },
    app_key: {
      label: 'APIキー',
      placeholder: 'APIキーを入力してください',
    },
    db_id: {
      label: 'DB ID',
      placeholder: 'DB IDを入力してください',
    },
    db_key: {
      label: 'DBキー',
      placeholder: 'DBキーを入力してください',
    },
    next: '次へ',
    cluster_db: {
      title: 'データベース選択',
      label: 'Cluster DB',
      placeholder: 'Cluster DBを選択してください',
    },
    back: '戻る',
    cancel: 'キャンセル',
    OK: 'OK',
    finish: '完了',
    no_options: 'オプションなし',
  },
  dashboard: {
    male_female: '男女',
    visits: '訪問数',
    age: '年齢',
    child: '子供',
    more: '以上',
    image: '画像',
    id_number: 'ID番号',
    gender: '性別',
    timestamp: '最終時刻',
    stay_time: '滞在時間',
    attribute_graph: '属性統計グラフ',
    unique_user: '1週間のユニークユーザ数',
  },
  message_error: {
    no_data: '表示するデータはありません。',
    app_config:
      '入力された APP ID、APPキー、DB ID または DBキーが正しくありません。',
    internal_server:
      'サーバーでエラーが発生しました。管理者に問い合わせてください。',
    format_url: '正しい形式でURLを入力してください。',
    url_invalid: 'URLが有効ではありません。',
  },
};
